import axios from "axios";
import { toast } from "react-toastify";
import { pdsrUrls } from "../../../../URL/ApplicationUrls";
import { PdsrId } from "../PdsrId";
import { combinedUrls } from "../../../../URL/functions";
import { confirm } from "../../../../Layout/Dialog/ConfirmDialog";

export const usePdsrToolbarActions = () => {
  // Expire container
  async function expireContainer(pdsrId: PdsrId, selectedIds: Array<number>) {
    const data = { ContainerTypeIds: selectedIds };

    const url = combinedUrls(pdsrUrls.containersForPdsrWithId(pdsrId), "/Expire");

    const fetchPromise = axios.post(url, data);
    await toast.promise(fetchPromise, {
      pending: "Loading",
      success: "Container type(s) was successfully expired",
      error: "Error while expire container type(s)",
    });
  }

  // Delete Container
  async function deleteContainer(pdsrId: PdsrId, selectedIds: Array<number>) {
    const isConfirmed = await confirm("Do you really want to delete selected items");
    if (!isConfirmed) {
      return;
    }
    const fetchPromise = axios.delete(pdsrUrls.containersForPdsrWithId(pdsrId), {
      data: {
        ids: selectedIds,
      },
    });
    await toast.promise(fetchPromise, {
      pending: "Loading",
      success: "Items have been deleted",
      error: "Error while deleting items",
    });
  }

  return {
    expireContainer,
    deleteContainer,
  };
};
